import styled from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  margin-left: 18px;
  margin-top: 30px;

  @media only screen and (min-width: 768px) {
    margin-top: 34px;
    margin-left: 64px;
  }
`;

export default Wrapper(template);
